import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import loginImage from "../../assets/login/login.png";
import { ThreeDots } from 'react-loader-spinner';
import OTPInput from 'react-otp-input';
import axiosInstance from '../../utils/axiosInstance';
import { useUserContext } from '../../globalComponent/context/AppContext';

const EnterOtp = ({ phoneNumber, setOtpSent }) => {
  const navigate = useNavigate()
  const { setUserId } = useUserContext()

  const [ otp, setOtp] = useState('');
  const [ timer, setTimer] = useState(60); // 1-minute timer
  const [ isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [ loader, setLoader] = useState(false);

  // Timer logic
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(interval);
    } else {
      setIsButtonDisabled(false); // Enable the button when timer hits 0
    }
  }, [timer]);

  const handleResendOtp = () => {
    axiosInstance
    .post("/resendotplogin", { phoneNumber: `${phoneNumber}` })
    .then(res => {
        console.log(res)
        setIsButtonDisabled(true);
        setTimer(60);
    }) 
    .catch(err => {
        console.error(err)
    })
  };

  const handleSendOtp = () => {
    setLoader(true);
    // Logic to verify OTP

    axiosInstance
        .post("/verifyloginotp/", { phone_number: `${phoneNumber}`, otp: `${otp}`})
        .then(res => {
            console.log(res)
            const response = res.data.data
            const userName = response.user.first_name + " " + response.user.last_name
            console.log(res.data.data)
            localStorage.setItem("access", res.data.data.access)
            localStorage.setItem("refresh", res.data.data.refresh)
            localStorage.setItem("name", userName)
            console.log(response)
            setUserId(response.user.id)
            navigate("/send-courier")
        })
        .catch(err => {
            console.error(err)
        })
        .finally(() => {
            setLoader(false)
        })
  };


  return (
    <div className='w-full lg:w-1/2 h-full pt-10 px-6 flex flex-col items-center justify-start lg:justify-center'>
      
      <p className='hidden lg:block text-center text-orange-600 supermercado text-3xl'>
          Sign In
      </p>

      <div className='w-full lg:mt-6 items-center justify-center'>
          <p className='text-2xl text-center text-slate-400 supermercado pb-4'>
              Welcome
          </p>
      </div>

      <div className='w-full aspect-square mb-5 lg:hidden'>
        <img
          src={loginImage}
          className='w-full h-full object-cover'
          alt='login'
        />
      </div>

      <p className='text-center text-xs pt-4 text-black text-opacity-40'>
        Otp sent to {phoneNumber}.{" "}<span onClick={() => setOtpSent(false)} className='text-orange-600'>edit?</span>
      </p>

      <div className='mt-5 text-left'>
        {/* <label className='text-left text-orange-600'>OTP:</label> */}
        <div className='flex items-center justify-center gap-2 py-5'>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={4}
            renderSeparator={<span className='text-2xl text-orange-600 mx-2'>-</span>}
            renderInput={(props) => <input {...props} />}
            inputStyle={{
                width: '50px', // Increase width
                height: '60px', // Increase height
                border: '2px solid #ea580c', // Orange-600 color
                borderRadius: '8px', // Rounded corners
                fontSize: '24px', // Increase font size
                textAlign: 'center', // Center the input text
                color: '#000', // Set text color
              }}
          />
        </div>
      </div>

      <button
        disabled={loader}
        onClick={handleSendOtp}
        className='bg-orange-600 mt-3 max-w-[17.815rem] disabled:bg-black disabled:bg-opacity-20 w-full flex items-center justify-center h-10 rounded-xl font-medium text-white'
      >
        {loader ? <ThreeDots color='#fff' /> : 'Enter'}
      </button>

      <div className='mt-4 text-center'>
        <button
          disabled={isButtonDisabled}
          onClick={handleResendOtp}
          className={`mt-5 w-full flex items-center justify-center h-10 rounded-xl font-medium ${
            isButtonDisabled ? 'text-black text-opacity-20' : 'text-orange-600 '
          }`}
        >
          Resend OTP {isButtonDisabled && `(${timer}s)`}
        </button>
      </div>
    </div>
  );
};

export default EnterOtp;